import {
  createContext,
  useCallback,
  useState,
  useMemo,
} from "react";
import { Alert, Fade } from "reactstrap";

export const AlertContext = createContext();
// Auto dispose Queue Alert support multiple alert 
/*
How to apply
import { AlertContext } from "utils/contexts";
const { displayAlert } = useContext(AlertContext);
displayAlert("Hi", "success");
*/
const validAlertTypes = ["success", "danger", "info", "warning"];
export const AlertProvider = ({ children }) => {
  const [alerts, setAlerts] = useState([]);

  const displayAlert = useCallback((message, type = "success") => {
    const newAlert = { id: Date.now(), message, type };
    setAlerts((currentAlerts) => [...currentAlerts, newAlert]);
    if (type==="danger") console.warn(newAlert);
    else console.log(newAlert);
    setTimeout(() => {
      setAlerts((currentAlerts) =>
        currentAlerts.filter((alert) => alert.id !== newAlert.id)
      );
    }, 5000);
  }, []);

  const defaultMessage = {
    success: "Successful operations",
    danger: "Something went wrong, Please try again",
    "": "This is an alert",
  };

  function getMessage(alert) {
    if (alert?.message) {
      return alert.message;
    }
    return defaultMessage[alert.type] || defaultMessage[""];
  }

  const dismissAlert = useCallback((id) => {
    setAlerts((currentAlerts) =>
      currentAlerts.filter((alert) => alert.id !== id)
    );
  }, []);

  const contextValue = useMemo(() => ({ displayAlert }), [displayAlert]);

  return (
    <AlertContext.Provider value={contextValue}>
      {children}
      {
        <div
          className="fixed-top container"
          style={{ marginTop: "15px", zIndex: "99999" }}
        >
          {alerts.map((alert) => (
            <Fade key={alert.id} in={true} tag="div">
              <Alert 
                color={validAlertTypes.includes(alert.type) ? alert.type : "danger"}
                toggle={() => dismissAlert(alert.id)}
                className="innerDisplayHTML"
                >
                {getMessage(alert)}
              </Alert>
            </Fade>
          ))}
        </div>
      }
    </AlertContext.Provider>
  );
};